import adyen from '../assets/adyen.svg'
import authorize from '../assets/authorizenet.svg'
import nmi from '../assets/nmi.svg'
import paypal from '../assets/paypal.svg'
import Razorpay from '../assets/razorpay-logo.svg'
import square from '../assets/square.svg'
import stripe from '../assets/stripe.svg'
import AppState from '../states/app'

const paymentMethods = [
  {
    key: 'stripe',
    image: stripe,
    name: 'Stripe',
    isSupported: true,
    exclude: false,
  },
  {
    key: 'nmi',
    image: nmi,
    name: 'NMI',
    isSupported: true,
    exclude: false,
  },
  {
    key: 'paypal',
    image: paypal,
    name: 'Paypal',
    isSupported: false,
    exclude: true,
  },
  {
    key: 'authorize-net',
    image: authorize,
    name: 'Authorize.net',
    isSupported: true,
    exclude: false,
  },
  {
    key: 'square',
    image: square,
    name: 'Square',
    isSupported: true,
    exclude: false,
  },
  {
    key: 'adyen',
    image: adyen,
    name: 'Adyen',
    isSupported: true,
    exclude: false,
  },
  {
    key: 'custom-provider',
    image: Razorpay,
    name: 'Custom Provider',
    isSupported: true,
    exclude: true,
  },
]

export const getDefaulPaymentMethod = (key: string) => {
  const paymentMethodImage = paymentMethods.find(
    method => method.key === key
  )?.image
  if (!paymentMethodImage) {
    return AppState.paymentProviderInfo?.imageUrl
  }
  return paymentMethodImage
}

export const getSupportedPaymentProviders = () => {
  return ['Stripe', 'NMI', 'Authorize.net', 'Square', 'Razorpay', 'PayPal']
}
